export default {
  setErpMerchList(state, erpMerchList) {
    state.erpMerchList = erpMerchList
  },
  setBrandList(state, brandList) {
    state.brandList = brandList
  },
  setStorehouseList(state, storehouseList) {
    state.storehouseList = storehouseList
  },
  setShelvesList(state, shelvesList) {
    state.shelvesList = shelvesList
  },
  setManagerList(state, managerList) {
    state.managerList = managerList
  },
  setCategoryTreeList(state, categoryTreeList) {
    state.categoryTreeList = categoryTreeList
  },
  setSupplierList(state, supplierList) {
    state.supplierList = supplierList
  },
  setUnitList(state, unitList) {
    state.unitList = unitList
  },
  setExpireList(state, expireList) {
    state.expireList = expireList
  },
  setUserStoreHouseList(state, userStoreHouseList) {
    state.userStoreHouseList = userStoreHouseList
  },
  setInStockTypeList(state, inStockTypeList) {
    state.inStockTypeList = inStockTypeList
  },
  setOutStockTypeList(state, outStockTypeList) {
    state.outStockTypeList = outStockTypeList
  },
  clearCategoryTreeList(state) {
    state.categoryTreeList = []
  },
  clearUserStorehouseList(state) {
    state.userStoreHouseList = []
  },
  clearBrandList(state) {
    state.brandList = []
  },
  clearUnitList(state) {
    state.unitList = []
  },
  clearSupplierList(state) {
    state.supplierList = []
  },
  clearDownList(state) {
    state.erpMerchList = []
    state.brandList = []
    state.storehouseList = []
    state.shelvesList = []
    state.managerList = []
    state.categoryTreeList = []
    state.supplierList = []
    state.unitList = []
    state.expireList = []
    state.userStoreHouseList = []
    state.inStockTypeList = []
    state.outStockTypeList = []
  }
}



// WEBPACK FOOTER //
// ./src/store/erp/mutations.js